import React, { useState, useEffect } from 'react';
import NavTabs from './components/NavTabs';
import HomePage from './pages/HomePage';
import ProjectsPage from './pages/ProjectsPage';
import BlogPage from './pages/BlogPage';
import ContactPage from './pages/ContactPage';
import Footer from './components/Footer';

const pageComponents = {
  Home: HomePage,
  Projects: ProjectsPage,
  Blog: BlogPage,
  Contact: ContactPage
};

const App = () => {
  const [currentPage, setCurrentPage] = useState('Home');
  const handlePageChange = (page) => setCurrentPage(page);
  const PageComponent = pageComponents[currentPage] || HomePage;
  useEffect(() => {
    document.title = `${currentPage} | My Website`;
  }, [currentPage]);


return (
    <>
      <NavTabs currentPage={currentPage} handlePageChange={handlePageChange}/>
      <PageComponent/>
      <Footer/>
    </>
  );
}

export default App;